import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Heart, X, ArrowRight } from 'lucide-react';
import { usePicks } from '../../context/PicksContext';
import { clearPicksFromUrl } from '../../utils/picksShare';

export function SharedPicksBanner() {
  const { state, openSharedModal, dismissSharedBanner, clearShared } = usePicks();
  const shared = state.shared;

  if (!shared || !shared.showBanner) return null;
  const validCount = shared.items.filter((i) => i.status === 'ok').length;
  if (validCount === 0 && shared.items.length === 0) return null;

  const handleDismiss = () => {
    dismissSharedBanner();
    // If modal isn't active either, fully clear and strip URL
    setTimeout(() => {
      if (!state.shared?.showModal) {
        clearShared();
        clearPicksFromUrl();
      }
    }, 300);
  };

  return (
    <AnimatePresence>
      <motion.div
        initial={{ height: 0, opacity: 0 }}
        animate={{ height: 'auto', opacity: 1 }}
        exit={{ height: 0, opacity: 0 }}
        transition={{ duration: 0.3 }}
        className="bg-gradient-to-r from-[#7B68CC] to-[#9B7ED6] text-white relative z-30 overflow-hidden"
      >
        <div className="container-max section-padding py-3">
          <div className="flex items-center gap-3">
            <div className="bg-white/20 rounded-xl p-2 flex-shrink-0">
              <Heart size={18} fill="currentColor" />
            </div>
            <div className="flex-1 min-w-0">
              <p className="font-semibold text-sm sm:text-base leading-tight">
                {shared.isReorder ? 'Welcome back — ready to reorder?' : 'Someone shared their picks with you'}
              </p>
              <p className="text-xs text-white/80 mt-0.5">
                {shared.isReorder
                  ? `${validCount} ${validCount === 1 ? 'item' : 'items'} from your last order`
                  : `${validCount} ${validCount === 1 ? 'item' : 'items'} ready to view`}
              </p>
            </div>
            <button
              onClick={openSharedModal}
              className="flex-shrink-0 flex items-center gap-1.5 bg-white text-[#7B68CC] text-sm font-bold px-4 py-2 rounded-full hover:bg-white/90 transition-colors"
            >
              View
              <ArrowRight size={14} />
            </button>
            <button
              onClick={handleDismiss}
              className="flex-shrink-0 p-2 text-white/70 hover:text-white hover:bg-white/10 rounded-lg transition-colors"
              aria-label="Dismiss shared picks"
            >
              <X size={16} />
            </button>
          </div>
        </div>
      </motion.div>
    </AnimatePresence>
  );
}
